import { render, staticRenderFns } from "./AMLoginComponent.vue?vue&type=template&id=2b821cfa&scoped=true"
import script from "./AMLoginComponent.vue?vue&type=script&lang=js"
export * from "./AMLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./AMLoginComponent.vue?vue&type=style&index=0&id=2b821cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b821cfa",
  null
  
)

export default component.exports